/**
 * Les témoignages d'acheteurs — 02/10/2026.
 *
 * ## Pourquoi la liste est vide
 *
 * Les trois témoignages qui occupaient autrefois l'accueil étaient signés
 * « — exemple » : la règle n° 6 les a fait retirer. La place de la preuve est
 * restée vide depuis, alors que le produit a eu de vrais acheteurs. Cette liste
 * la rouvre, **pour de vrais témoignages seulement** : tant qu'elle est vide, la
 * section ne s'affiche pas.
 *
 * ## Ce qu'une entrée exige
 *
 * - un texte écrit par l'acheteur, recopié sans retouche autre que
 *   l'orthographe ;
 * - un prénom (ou une initiale) et un métier, rien qui permette de joindre la
 *   personne ;
 * - **l'accord écrit** de la personne pour cette publication, daté, avec le
 *   canal par lequel il a été donné (« WhatsApp, 12/10/2026 »). Une entrée sans
 *   accord n'est pas publiée, et `temoignages.test.ts` refuse qu'elle soit
 *   ajoutée.
 *
 * ## Comment les recueillir
 *
 * Aux acheteurs dont le contact est encore conservé, une semaine après leur
 * rapport, par le canal par lequel ils l'ont reçu :
 *
 * > Bonjour, vous avez reçu votre rapport STRATERA il y a une semaine. En une
 * > ou deux phrases, qu'est-ce qu'il vous a apporté ? Si vous êtes d'accord,
 * > nous publierions votre réponse sur le site avec votre prénom et votre
 * > métier seulement. Répondez « d'accord » pour l'autoriser.
 */
export interface Temoignage {
  /** Les mots de l'acheteur. */
  texte: string;
  /** Prénom ou initiale — jamais le nom complet. */
  prenom: string;
  metier: string;
  /** L'accord écrit : canal et date. Vide = non publiable. */
  accord: string;
}

export const TEMOIGNAGES: ReadonlyArray<Temoignage> = [];

/** Les témoignages qui peuvent paraître : complets, et accordés par écrit. */
export function temoignagesPubliables(liste: ReadonlyArray<Temoignage>): Temoignage[] {
  return liste.filter((t) => [t.texte, t.prenom, t.metier, t.accord].every((champ) => champ.trim().length > 0));
}
